export enum AccountingEventType {
  CREDIT = 'credit-note',
  INVOICE = 'invoice',
  USAGE_INVOICE = 'usage_invoice',
  DEBIT = 'debit-note',
  REVREC = 'revenue-recognition',
  PAYOUT = 'payout',
}

// Purchase Order type constant - separate from AccountingEventType since POs are not stored documents
// This is used for PDF preview functionality only
export const PURCHASE_ORDER_DOCUMENT_TYPE = 'purchase-order' as const;
export type PurchaseOrderDocumentType = typeof PURCHASE_ORDER_DOCUMENT_TYPE;
